export const FETCH_USERUNINSTALL_REQUEST = 'FETCH_USERUNINSTALL_REQUEST';
export const FETCH_USERUNINSTALL_SUCCESS = 'FETCH_USERUNINSTALL_SUCCESS';
export const FETCH_USERUNINSTALL_FAILURE = 'FETCH_USERUNINSTALL_FAILURE';

export const SEARCH_USERUNINSTALL_REQUEST = 'SEARCH_USERUNINSTALL_REQUEST';
export const SEARCH_USERUNINSTALL_SUCCESS = 'SEARCH_USERUNINSTALL_SUCCESS';
export const SEARCH_USERUNINSTALL_FAILURE = 'SEARCH_USERUNINSTALL_FAILURE';

export const fetchUninstallRequest = (page, limit) => ({
  type: FETCH_USERUNINSTALL_REQUEST,
  payload: { page, limit },
});

export const fetchUninstallSuccess = (userUninstall) => ({
  type: FETCH_USERUNINSTALL_SUCCESS,
  payload: userUninstall,
});

export const fetchUninstallFailure = (error) => ({
  type: FETCH_USERUNINSTALL_FAILURE,
  payload: error,
});

export const searchUninstallSurveyRequest = (searchTerm) => ({
  type: SEARCH_USERUNINSTALL_REQUEST,
  payload: { searchTerm },
});

export const searchUninstallSurveySuccess = (userUninstall) => ({
  type: SEARCH_USERUNINSTALL_SUCCESS,
  payload: userUninstall,
});

export const searchUninstallSurveyFailure = (error) => ({
  type: SEARCH_USERUNINSTALL_FAILURE,
  payload: error,
});